import * as ACTION_TYPES from './types';
import { CONTEXT_MENU_CHANGE_TYPE } from './../contextMenu/types';

const initialState = {
  status: {
    loading: -1,
  },
  ids: [],
  meta: {},
  error: null,
};

export default function reducer(state = initialState, action) {
  const { type, payload, error } = action;

  switch (type) {
    case ACTION_TYPES.MESSAGES_SEARCH_REQUESTED:
      return {
        ...state,
        status: {
          ...state.status,
          loading: 0,
        },
      };
    case ACTION_TYPES.MESSAGES_SEARCH_SUCCEED: {
      return {
        ...state,
        ids: payload.result.data,
        meta: payload.result.meta,
        status: {
          ...state.status,
          loading: 1,
        },
      };
    }
    case ACTION_TYPES.MESSAGES_SEARCH_FAILED:
      return {
        ...state,
        status: {
          ...state.status,
          loading: 2,
        },
        error,
      };
    case ACTION_TYPES.MESSAGES_SEARCH_LOAD_MORE_SUCCEED:
      return {
        ...state,
        ids: [...state.ids, ...payload.result.data],
        meta: payload.result.meta,
        status: {
          ...state.status,
          loading: 1,
        },
      };
    case CONTEXT_MENU_CHANGE_TYPE:
      return initialState;
    default:
      return state;
  }
}
